import React from 'react';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';
import EsignWorkflowDiagram from './EsignWorkflowDiagram';

function Services() {
  const serviceFaqs = [
    {
      q: "What fintech services does Mokshiq provide?",
      a: "Mokshiq provides AEPS Biometric Banking, Domestic Money Transfer (DMT), Micro ATM POS terminals, Utility Bill Payments (BBPS), Prepaid Mobile/DTH Recharges, and Verify Verification APIs."
    },
    {
      q: "How can I get started as a retailer or distributor?",
      a: "You can sign up on our portal or contact our onboarding team. Once KYC verification is complete, your wallet will be activated immediately."
    },
    {
      q: "Are Mokshiq APIs developer-friendly?",
      a: "Yes, our Verify and Recharge APIs come with comprehensive REST documentation, SDKs, sandbox environments, and 99.9% uptime SLAs."
    },
    {
      q: "What is the commission payout structure?",
      a: "We offer industry-leading instant commission payouts credited directly to your agent wallet on every successful transaction with real-time reporting."
    }
  ];

  return (
    <div className="page_wrapper bg-dark-emerald text-white">
      <Header />
      <main className="page_content">

        {/* Page Banner Header */}
        <section className="page_header text-center py-5 section_decoration overflow-hidden position-relative" style={{ backgroundColor: '#001a14', borderBottom: '1px solid rgba(204, 255, 0, 0.15)' }}>
          <div className="container py-4">
            <span className="badge-lime mb-3 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-cubes me-2"></i>ENTERPRISE FINTECH SUITE
            </span>
            <h1 className="page_title text-white display-5 font-weight-bold mb-3">Fintech, Software &amp; API Services</h1>
            <p className="text-white-50 mx-auto lead" style={{ maxWidth: '750px', fontSize: '1.05rem', lineHeight: '1.7' }}>
              Empowering merchants, distributors, and developers with bank-grade APIs, white-label portals, and identity verification tools powered by <strong className="text-lime">Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center d-flex gap-2 p-0 m-0 list-unstyled small text-white-50 mt-3">
              <li><a href="/" className="text-lime text-decoration-none font-weight-bold">Home</a></li>
              <li>/</li>
              <li className="text-white font-weight-bold">Services</li>
            </ul>
          </div>
        </section>

        {/* Value Proposition & 3 Pillars with 3D Icons */}
        <section className="feature_section py-5" style={{ backgroundColor: '#012b2a' }}>
          <div className="container py-3">
            
            <div className="heading_block mb-5">
              <div className="row justify-content-lg-between align-items-center g-4">
                <div className="col-lg-5">
                  <span className="badge-lime mb-2 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
                    WHY PARTNER WITH US
                  </span>
                  <h2 className="heading_text text-white display-6 font-weight-bold mt-1">
                    Why Our Fintech Services Excel
                  </h2>
                </div>
                <div className="col-lg-6">
                  <p className="heading_description text-white-50 mb-0" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                    Mokshiq (a product of <strong className="text-lime">Rakle Service Private Limited</strong>) offers bank-grade stability, developer-first APIs, high commission payouts, and 99.9% automated uptime SLA.
                  </p>
                </div>
              </div>
            </div>

            {/* 3 Pillars Cards with 3D Icons & Interactive Hover */}
            <div className="row g-4">
              
              {/* Card 1: Our Mission */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/mission_3d_target.png" alt="Our Mission 3D" width="44" height="44" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Our Mission</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      To empower retailers, master distributors, and fintech developers with seamless banking, verification, and payment infrastructure.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2: Verify & Banking */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/offer_3d_services.png" alt="Verify & Banking 3D" width="44" height="44" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Verify &amp; Banking</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Instant Bank Penny Drop, PAN, Aadhaar OTP, GSTIN verification APIs combined with AEPS, DMT, and Recharge solutions.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3: Why Choose Us */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/choose_3d_growth.png" alt="Why Choose Us 3D" width="44" height="44" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Why Choose Us</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Direct connections with bank nodes, zero pending transactions, transparent commission reporting, and 24x7 hotline support.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Multi-Signer Contract eSign Diagram Graphic Section */}
        <section className="py-5" style={{ backgroundColor: '#001a14', borderTop: '1px solid rgba(204, 255, 0, 0.1)', borderBottom: '1px solid rgba(204, 255, 0, 0.1)' }}>
          <div className="container py-2">
            <EsignWorkflowDiagram title="Multi-Signer Contract Agreement &amp; Digital eSign Workflow" />
          </div>
        </section>

        {/* Primary Product Verticals Grid */}
        <section className="service_section py-5" style={{ backgroundColor: '#012b2a' }}>
          <div className="container py-3">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-7 text-center">
                <span className="badge-lime mb-2 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
                  OUR PRODUCT VERTICALS
                </span>
                <h2 className="heading_text text-white display-6 font-weight-bold">Comprehensive Fintech Solutions</h2>
                <p className="heading_description mb-0 text-white-50">
                  Select a service vertical below to explore features, commission structures, and developer API documentation.
                </p>
              </div>
            </div>

            <div className="row g-4">
              
              {/* Verify */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/services/service_3d_banking.png" alt="Verify 3D" width="46" height="46" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Verify APIs</h3>
                    </div>
                    <p className="text-white-50 small mb-4" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Instant Bank Account Penny Drop, PAN, Aadhaar OTP, GSTIN, UPI VPA, and Vehicle RC verification API suite.
                    </p>
                  </div>
                  <div>
                    <a className="text-lime text-decoration-none fw-bold small d-inline-flex align-items-center gap-2" href="/verify">
                      <span>Explore Verification APIs</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* Recharge API */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/services/service_3d_recharge.png" alt="Recharge API 3D" width="46" height="46" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Recharge API &amp; B2B Portal</h3>
                    </div>
                    <p className="text-white-50 small mb-4" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      High-speed Prepaid Mobile (Jio, Airtel, Vi, BSNL) &amp; DTH recharge API with Automatic LAPU fallback switcher.
                    </p>
                  </div>
                  <div>
                    <a className="text-lime text-decoration-none fw-bold small d-inline-flex align-items-center gap-2" href="/recharge_api">
                      <span>Explore Recharge API</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* AEPS & DMT */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/services/service_3d_utility.png" alt="AEPS Banking 3D" width="46" height="46" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">AEPS &amp; Domestic Remittance</h3>
                    </div>
                    <p className="text-white-50 small mb-4" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Biometric Cash Withdrawal, Aadhaar Pay, Mini Statement, 24x7 IMPS Money Transfer, and Micro ATM solutions.
                    </p>
                  </div>
                  <div>
                    <a className="text-lime text-decoration-none fw-bold small d-inline-flex align-items-center gap-2" href="/aeps_dmt_services">
                      <span>Explore Banking Suite</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <div className="bg-dark-emerald py-4">
          <FAQ 
            faqList={serviceFaqs}
            title="Services &amp; Platform Frequently Asked Questions"
            subtitle="Common queries regarding starting as a retailer, distributor, or API partner on Mokshiq."
            isDark={true}
          />
        </div>

      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default Services;